export function Item1() {
  return (
    <>
      <p className="text-lg font-medium text-blue-200 mt-6">
        A Simya Capital atua diretamente no mercado de direitos creditórios,
        incluindo créditos corporativos não adimplidos - Non Performing Loan
        (NPL) e decorrentes de ações judiciais entre entes privados - Legal
        Claims.
      </p>
      <p className="text-lg font-medium text-blue-200 mt-4 underline">
        Aquisição direta:
      </p>
      <p className="text-lg font-medium text-blue-200 mt-4">
        Realizamos a aquisição direta de direitos creditórios single name e de
        carteiras judiciais ou extrajudiciais.
      </p>
      <p className="text-lg font-medium text-blue-200 mt-4 underline">
        Aquisição por terceiros:
      </p>
      <p className="text-lg font-medium text-blue-200 mt-4">
        Fornecemos assessoria especializada na estruturação de operações para
        financiamento de aquisições, além do apoio de uma extensa rede de
        contatos que inclui os principais players do mercado, como instituições
        financeiras e investidores.
      </p>
      <p className="text-lg font-medium text-blue-200 mt-4 underline">
        Avaliação de carteiras de crédito:
      </p>
      <p className="text-lg font-medium text-blue-200 mt-4">
        Assessoramos os clientes na avaliação de créditos individuais e
        carteiras, massificados ou não, em operações de compra e venda e
        reavaliação de ativos.
      </p>
      <p className="text-lg font-medium text-blue-200 mt-4 underline">
        Precatórios e pré-precatórios:
      </p>
      <p className="text-lg font-medium text-blue-200 mt-4">
        Atuamos na compra e na assessoria de transações envolvendo créditos
        perante entes púbicos - RPVs, precatórios e pré-precatórios.
      </p>
    </>
  );
}
